import React, { useState, useEffect, useContext, forwardRef, useImperativeHandle, useRef } from 'react';
import { Modal, Checkbox } from 'antd';
import utils from '../../../utils';
import http from '../../../Http';
import { useTranslation } from 'react-i18next';

const ForceSOCCalibration = forwardRef((props, ref) => {
    const { t } = useTranslation();
    const setTip = useContext(utils.tipContext);
    const { sns } = { ...props };

    const [selectedSns, setSelectedSns] = useState([]);
    const selectedSnsRef = useRef(selectedSns);

    useEffect(() => {
        setSelectedSns(sns);
        selectedSnsRef.current = sns;
    }, [sns]);

    useEffect(() => {
        selectedSnsRef.current = selectedSns;
    }, [selectedSns]);

    const doForcingSOCCalibration = () => {
        Modal.confirm({
            maskClosable: false,
            title: t("Force SOC Calibration"),
            content: <>
                <div style={{ color: "red", fontWeight: "bold" }}>{t("All batteries connected to the following inverters will be forcibly charged to 100% (SOC). Please confirm!")}</div>
                <br />
                <div>
                    <Checkbox.Group options={sns} defaultValue={selectedSns} onChange={
                        vs => setSelectedSns(vs) // Use functional update to ensure state consistency
                    } />
                </div>
            </>,
            onOk: async () => {
                const currentSelectedSns = selectedSnsRef.current;

                if (currentSelectedSns.length == 0) {
                    return;
                }

                let sns2 = [];
                try {
                    for (const sn of currentSelectedSns) {
                        const resp = await http.postJSON("integrated-inverter-v2/setting/request", {
                            SerialNumber: sn,
                            RW: "W",
                            InverterSettingParams: [{
                                Address: 0x1407,
                                Count: 1,
                                Data: [0, 2],
                            }],
                        }).then(async (r) => {
                            return await r.json();
                        }).catch((e) => {
                            console.log("[Force SOC Calibration]", e);
                            return null;
                        });

                        if (resp.data.SerialNumber != sn) {
                            setTip({ open: true, severity: "error", msg: t("SerialNumber not match") });
                            return;
                        }

                        if (resp.data.InverterSettingParams[0] && resp.data.InverterSettingParams[0].Result == 0) {
                            sns2.push(sn)
                        } else {
                            // setTip({ open: true, severity: "error", msg: t("Failed to request to Forced SOC calibration") });
                        }
                    }

                } catch (e) {
                    console.log("[Force SOC Calibration]", e);
                    setTip({ open: true, severity: "error", msg: t("Read-Write error") });
                } finally {
                    //
                }

                if (currentSelectedSns.length == sns2.length) {
                    setTip({ open: true, severity: "success", msg: t("Forced SOC calibration has been successfully requested") })
                } else if (sns2.length > 0) {
                    //setTip({open: true, severity: "warning", msg: t("Partially successful request for forced SOC calibration")})
                    Modal.warning({
                        title: t("Force SOC Calibration"),
                        content: `${t("Partially successful request for forced SOC calibration")}: ${sns2.join(", ")}`,
                    })
                } else {
                    setTip({ open: true, severity: "error", msg: t("Failed to request to Forced SOC calibration") });
                }
            },
        });
    }

    useImperativeHandle(ref, () => ({
        doForcingSOCCalibration: doForcingSOCCalibration
    }));

    return null;
});

export default ForceSOCCalibration;